import {
  Component,
  ContentChild,
  AfterContentInit,
  TemplateRef,
  Input,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectorRef
} from '@angular/core';

@Component({
    selector: 'pme-carousel-swiper',
    templateUrl: './carousel-swiper.component.html',
    styleUrls: ['./carousel-swiper.component.scss'],
    standalone: false
})
export class CarouselSwiperComponent implements AfterContentInit, AfterViewInit, OnDestroy {
  @Input() identifier: string = '';
  @Input() items: any[] = [];
  @ContentChild(TemplateRef) slideTemplate!: TemplateRef<any>;

  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  hasOverflow = false;
  isAtStart = true;
  isAtEnd = false;
  private resizeObserver!: ResizeObserver;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterContentInit() {}

  ngAfterViewInit() {
    this.resizeObserver = new ResizeObserver(() => this.checkOverflow());
    this.resizeObserver.observe(this.scrollContainer.nativeElement);
    this.checkOverflow();
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
  }

  public update() {
    this.checkOverflow();
  }

  private checkOverflow() {
    const el = this.scrollContainer?.nativeElement;
    if (el) {
      this.hasOverflow = el.scrollWidth > el.clientWidth;
      this.checkScrollPosition();
      this.cdr.markForCheck();
    }
  }

  private checkScrollPosition() {
    const el = this.scrollContainer?.nativeElement;
    if (el) {
      this.isAtStart = el.scrollLeft <= 0;
      this.isAtEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
      this.cdr.markForCheck();
    }
  }

  onScroll() {
    this.checkScrollPosition();
  }

  scrollPrev() {
    this.scrollContainer?.nativeElement.scrollBy({ left: -300, behavior: 'smooth' });
  }

  scrollNext() {
    this.scrollContainer?.nativeElement.scrollBy({ left: 300, behavior: 'smooth' });
  }
}
